<template>
    <div class="pay-dialog" v-loading="loading" :class="{black_mode:page_mode?true:false}">
        <div class="pay_left">
            <div class="pay_panel">
                <div class="pay_heading">
                    <div class="pay_heading_title">{{ paySceneTitle }}</div>
                    <div class="pay_heading_desc">{{ paySceneDesc }}</div>
                </div>
                <div class="pay_code" v-loading="scanLoad">
                    <div class="weixin_pay_code" ref="payCode" id="payCode" v-if="type=='weixin'"></div>
                    <iframe class="alipay_pay_iframe" :srcdoc="alipayCode" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" style="overflow:hidden;" v-else></iframe>
                </div>
                <div class="pay_tip">请使用{{ type === 'weixin' ? '微信' : '支付宝' }}扫码完成支付</div>
            </div>
            <div class="pay_type">
                <div class="type_item" :class="{'type_active':type=='weixin'}" @click="onTabPay('weixin')">
                    <span class="type_icon wechat_icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <circle cx="10" cy="10" r="7"></circle>
                            <circle cx="16.5" cy="14.5" r="5.5"></circle>
                            <circle class="dot" cx="7.5" cy="9.5" r="1"></circle>
                            <circle class="dot" cx="11.5" cy="9.5" r="1"></circle>
                            <circle class="dot" cx="14.8" cy="14.2" r="0.9"></circle>
                            <circle class="dot" cx="17.4" cy="14.2" r="0.9"></circle>
                        </svg>
                    </span>
                    <span>微信支付</span>
                </div>
                <div class="type_item" :class="{'type_active':type=='alipay'}" @click="onTabPay('alipay')">
                    <span class="type_icon alipay_icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path class="mark" d="M8 7.5h7.3v1.8h-4.2v1.7h3.8v1.8h-3.8v1.4c1.5-.4 3.2-1 4.8-1.7l.8 1.7c-1.2.6-2.7 1.2-4.3 1.7 1.4.7 2.8 1.5 4.2 2.4l-1.2 1.6c-1.7-1.2-3.3-2.2-4.8-2.9-.7 1.7-2 2.6-4 2.6-.8 0-1.5-.2-2-.7-.5-.4-.8-1-.8-1.7 0-1.8 1.6-2.9 4.3-2.9.2 0 .4 0 .7 0v-1.5h-4.1V11h4.1V9.3H8V7.5z"></path>
                        </svg>
                    </span>
                    <span>支付宝</span>
                </div>
            </div>
        </div>
        <div class="pay_details">
            <div class="details_top">
                <div class="details_badge">{{ details.type_text || '订单支付' }}</div>
                <div class="details_amount">￥{{ details.amount || 0 }}</div>
            </div>
            <div class="details_card">
                <div class="details_item">
                    <div class="item_title">订单类型</div>
                    <div class="item_content">{{ details.type_text }}</div>
                </div>
                <div class="details_item">
                    <div class="item_title">订单编号</div>
                    <div class="item_content item_code">{{ details.sn }}</div>
                </div>
                <div class="details_item">
                    <div class="item_title">订单金额</div>
                    <div class="item_content item_price">￥{{ details.amount }}</div>
                </div>
            </div>
            <template v-if="isVipOrder">
                <div class="details_card details_primary">
                    <div class="card_title">会员信息</div>
                    <div class="details_item">
                        <div class="item_title">等级名称</div>
                        <div class="item_content">{{ details.group ? details.group.name : '' }}</div>
                    </div>
                    <div class="details_item">
                        <div class="item_title">等级时长</div>
                        <div class="item_content">{{ details.group_type_text }}</div>
                    </div>
                </div>
                <div class="details_note">
                    支付成功后，会员权益会立即生效，并按所选时长顺延累计。
                </div>
            </template>
            <template v-else-if="isPicOrder">
                <div class="details_card details_primary">
                    <div class="card_title">数据信息</div>
                    <div class="details_item">
                        <div class="item_title">数据名称</div>
                        <div class="item_content">{{ details.pic ? details.pic.name : '' }}</div>
                    </div>
                </div>
                <div class="details_note">
                    支付成功后，可前往订单详情查看并继续后续操作。
                </div>
            </template>
            <template v-else-if="isCardOrder">
                <div class="details_card details_primary">
                    <div class="card_title">体验卡信息</div>
                    <div class="details_item">
                        <div class="item_title">购买数量</div>
                        <div class="item_content">{{ details.card_num }}张</div>
                    </div>
                </div>
                <div class="details_note note_pre">{{ config.experience_desc ? config.experience_desc : '' }}</div>
            </template>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import { requestGetOrderDetails, requestGetOrderPay } from '@/api/app';
    import { mapGetters } from 'vuex';
    export default {
        name: "pay-dialog",
        props: {
            id: {
                default: null
            }
        },
        data(){
            return {
                details: {},
                loading: false,
                scanLoad: false,
                type: 'weixin',
                weixinCode: '',
                alipayCode: '',
            }
        },
        watch: {
            id:{
                immediate: true,
                handler(){
                    // 获取订单信息
                    this.getDetails();
                }
            }
        },
        computed:{
            ...mapGetters(['page_mode', 'config']),
            isVipOrder(){
                return Number(this.details.type || 0) === 1;
            },
            isPicOrder(){
                return Number(this.details.type || 0) === 2;
            },
            isCardOrder(){
                return Number(this.details.type || 0) === 3;
            },
            paySceneTitle(){
                if(this.isVipOrder) return '会员支付';
                if(this.isPicOrder) return '数据支付';
                if(this.isCardOrder) return '体验卡支付';
                return '订单支付';
            },
            paySceneDesc(){
                if(this.isVipOrder) return '请扫码完成会员订单支付';
                if(this.isPicOrder) return '请扫码完成数据订单支付';
                if(this.isCardOrder) return '请扫码完成体验卡订单支付';
                return '请扫码完成当前订单支付';
            }
        },
        methods: {
            // 切换支付方式
            onTabPay(type){
                if(type != this.type){
                    this.type = type;
                    if(this.type == 'weixin' && this.weixinCode){
                        setTimeout(()=>{
                            this.bindQRCode();
                        }, 100);
                    }
                    else if(this.type == 'alipay' && this.alipayCode){
                        return false;
                    }else{
                        // 获取支付数据
                        this.getPay();
                    }
                }
            },
            // 获取详情数据
            getDetails(){
                this.loading = true;
                requestGetOrderDetails(this.id).then(res=>{
                    this.loading = false;
                    this.details = res.data;
                    // 获取支付数据
                    this.getPay();
                })
            },
            // 获取支付数据
            getPay(){
                this.scanLoad = true;
                requestGetOrderPay(this.id, this.type).then(res=>{
                    let uri = res.data.uri;
                    if(this.type == 'weixin'){
                        this.weixinCode = uri;
                        this.bindQRCode();
                    }else{
                        this.alipayCode = uri;
                    }
                    this.scanLoad = false;
                })
            },
            // 生成二维码
            bindQRCode() {
                this.$refs.payCode.innerHTML = '';
                const boxSize = this.$refs.payCode ? this.$refs.payCode.clientWidth : 300;
                const qrcodeSize = Math.max(220, Math.min(272, boxSize - 28));
                new QRCode(this.$refs.payCode, {
                    text: this.weixinCode,
                    width: qrcodeSize,
                    height: qrcodeSize,
                    colorDark: "#333333", // 二维码颜色
                    colorLight: "#ffffff", // 二维码背景色
                    correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
                })
            }
        }
    }
</script>


<style lang="scss" scoped>
    .black_mode {
        .pay_panel,
        .pay_details {
            .details_item,
            .details_top,
            .details_note,
            .card_title,
            .pay_heading_title,
            .pay_heading_desc,
            .pay_tip {
                color: #FFFFFF!important;
            }
            .details_card {
                background: rgba(255, 255, 255, 0.03)!important;
                border-color: rgba(255, 255, 255, 0.08)!important;
            }
            .pay_code {
                background: rgba(255, 255, 255, 0.04)!important;
                border-color: rgba(255, 255, 255, 0.08)!important;
            }
            .item_code,
            .pay_heading_desc,
            .pay_tip,
            .details_note {
                color: rgba(255, 255, 255, 0.72)!important;
            }
            .details_badge {
                background: rgba(64, 158, 255, 0.16)!important;
                color: #8bc3ff!important;
            }
        }
    }
    .pay-dialog {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 600px;
        padding: 10px 0;
        box-sizing: border-box;
        .pay_left {
            width: 420px;
            min-height: 500px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-right: 38px;
            .pay_panel {
                padding: 22px 24px 18px;
                border-radius: 18px;
                background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));
                border: 1px solid rgba(228, 231, 237, 0.6);
            }
            .pay_heading {
                margin-bottom: 18px;
                .pay_heading_title {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 1;
                    color: #303133;
                }
                .pay_heading_desc {
                    margin-top: 10px;
                    font-size: 13px;
                    color: #909399;
                }
            }
            .pay_code {
                width: 100%;
                height: 360px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 16px;
                border: 1px solid #e4e7ed;
                background: rgba(255, 255, 255, 0.72);
                .weixin_pay_code {
                    width: 300px;
                    height: 300px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    padding: 10px;
                    border-radius: 12px;
                    border: 1px solid #e4e7ed;
                    background: #ffffff;
                    box-sizing: border-box;
                }
                .alipay_pay_iframe {
                    width: 320px;
                    height: 320px;
                    padding: 10px;
                    border-radius: 12px;
                    border: 1px solid #e4e7ed;
                    background: #ffffff;
                    box-sizing: border-box;
                }
            }
            .pay_tip {
                margin-top: 14px;
                font-size: 12px;
                color: #909399;
                text-align: center;
            }
            .pay_type {
                display: flex;
                justify-content: center;
                margin-top: 16px;
                .type_item {
                    width: 112px;
                    height: 38px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    border: 1px solid #e4e7ed;
                    cursor: pointer;
                    margin-left: 12px;
                    transition: all 0.2s ease;
                    gap: 8px;
                    &:first-child {
                        margin-left: 0;
                    }
                    .type_icon {
                        width: 18px;
                        height: 18px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        svg {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                    .wechat_icon {
                        svg {
                            circle {
                                fill: #1aad19;
                            }
                            .dot {
                                fill: #ffffff;
                            }
                        }
                    }
                    .alipay_icon {
                        svg {
                            circle {
                                fill: #1677ff;
                            }
                            .mark {
                                fill: #ffffff;
                            }
                        }
                    }
                }
                .type_active {
                    color: #409EFF;
                    border: 1px solid #409EFF;
                    background: rgba(64, 158, 255, 0.08);
                    box-shadow: 0 8px 16px rgba(64, 158, 255, 0.08);
                }
            }
        }
        .pay_details {
            width: 360px;
            min-height: 500px;
            padding-left: 36px;
            border-left: 2px solid #e4e7ed;
            .details_top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 18px;
                .details_badge {
                    padding: 7px 12px;
                    border-radius: 999px;
                    background: rgba(64, 158, 255, 0.1);
                    color: #409EFF;
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 1;
                }
                .details_amount {
                    font-size: 34px;
                    line-height: 1;
                    font-weight: 800;
                    color: #F56C6C;
                }
            }
            .details_card {
                padding: 18px 20px;
                border-radius: 16px;
                border: 1px solid rgba(228, 231, 237, 0.8);
                background: rgba(255, 255, 255, 0.4);
                margin-bottom: 16px;
            }
            .details_primary {
                border-color: rgba(64, 158, 255, 0.6);
            }
            .card_title {
                font-size: 14px;
                font-weight: 700;
                margin-bottom: 14px;
                color: #303133;
            }
            .details_item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 14px;
                color: #303133;
                &:last-child {
                    margin-bottom: 0;
                }
                .item_title {
                    font-size: 14px;
                    font-weight: 700;
                    color: inherit;
                    margin-right: 18px;
                    white-space: nowrap;
                }
                .item_content {
                    flex: 1;
                    min-width: 0;
                    text-align: right;
                    font-size: 14px;
                    line-height: 1.5;
                    color: inherit;
                }
                .item_price {
                    font-weight: bold;
                    color: #F56C6C;
                }
                .item_code {
                    color: #909399;
                    word-break: break-all;
                }
            }
            .details_note {
                font-size: 13px;
                line-height: 1.8;
                color: #606266;
            }
            .note_pre {
                white-space: pre-wrap;
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .pay-dialog {
            flex-direction: column;
            align-items: stretch;
            .pay_left {
                width: 100%;
                min-height: auto;
                margin-right: 0;
            }
            .pay_details {
                width: 100%;
                min-height: auto;
                margin-top: 24px;
                padding-left: 0;
                padding-top: 24px;
                border-left: 0;
                border-top: 2px solid #e4e7ed;
            }
        }
    }
</style>
